import api from '@/lib/api'

const state = () => ({
  // this way to handle booleans hurts my soul a little
  signedIn: localStorage.signedIn === 'true' || false,
  me: (localStorage.me && JSON.parse(localStorage.me)) || { user_id: -1, name: '', email: '', account_name: '', offered_services: []} ,

  referrals: [],
  unverifiedPro: '',
  unclaimedPro: {
    pro_id: -1,
    phone: '',
    email: '',
    lead_count: '0',
    accounts: [],
  },

  unclaimedProUser: {
    pro: {
      pro_id: -1,
      business_name: ''
    },
    pro_user_id: -1,
    contact_method: '',
    lead_count: '0',
  },

  acceptanceKeys: {
    user_id: '',
    acceptance_token: '',
  },
})

const getters = {
  signedIn:       state => state.signedIn == true,
  me:             state => state.me,
  referrals:      state => state.referrals,
  unverifiedPro:  state => state.unverifiedPro,
  unclaimedPro:   state => state.unclaimedPro,
  unclaimedProUser: state => state.unclaimedProUser,
  acceptanceKeys: state => state.acceptanceKeys,
}

async function updateMeHelper({ commit, dispatch }, newMe) {
  await dispatch('alerts/set_alerts', newMe.alerts, { root: true })
  commit('SET_ME', newMe)
  return { ok: true }  
}

const actions = {
  async loadMe({ commit, dispatch }) {
    const result = await api.get('/me')
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async resetPassword({ commit, dispatch }, payload) {
    const result = await api.insecure_post('/base/reset_password', payload)
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateMe({ commit, dispatch }, me) {
    const result = await api.put('/me', { me })
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  // this should be moved to services.js
  // eslint-disable-next-line no-empty-pattern
  async updateMyServices({ }, services) {
    const result = await api.put('/me/offered_services', services)
    if (result.ok) {
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateMyPassword({ commit, dispatch }, payload) {
    const result = await api.put('/me/password', payload)
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadUnclaimedPro( { commit }, pro_token ) {
    const result = await api.insecure_get(`/unclaimed_pro/${ pro_token }`)
    if (result.ok) {
      commit('SET_UNCLAIMED_PRO', await result.json())
      return { ok: true }  
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadUnclaimedProUser( { commit }, claim_token ) {
    const result = await api.insecure_get(`/unclaimed_pro_user/${ claim_token }`)
    if (result.ok) {
      commit('SET_UNCLAIMED_PRO_USER', await result.json())
      return { ok: true }  
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadReferrals({ commit }) {
    const result = await api.get('/me/referrals')
    if (result.ok) {
      commit('SET_REFERRALS', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async login({ commit, dispatch }, { user_id, password }) {
    const result = await api.insecure_post('/base/login', { user_id, password })
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async acceptAgreement({ commit, dispatch }, { user_id, acceptance_token }) {
    const result = await api.insecure_post('/base/accept_terms', { user_id, acceptance_token })
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  logout({ commit }) {
    api.post('/me/logout')
    commit('LOGOUT')
  },

  async updateAutoRenew({ commit, dispatch }, { auto_renew }) {
    const result = await api.put('/me/auto_renew', { auto_renew })
    if (result.ok) {
      return updateMeHelper({commit, dispatch}, await result.json())
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async createUserFromToken({ }, user ) {
    const result = await api.post('/users/create_from_token', { user })
    if (result.ok) {
      return { ok: true, created: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  }
}

const mutations = { 
  SET_ME (state, me) {
    state.signedIn = true; localStorage.signedIn = true
    state.me = me; localStorage.me = JSON.stringify(me)
  },

  LOGOUT (state) {
    state.signedIn = false; localStorage.signedIn = false
    state.me = { user_id: -1, name: '', email: '', account_name: ''}; localStorage.me = JSON.stringify(state.me)
  },

  SET_ACCEPTANCE_KEYS (state, { user_id, acceptance_token }) {
    state.acceptanceKeys.user_id = user_id
    state.acceptanceKeys.acceptance_token = acceptance_token
  },

  SET_ACCOUNT_NAME (state, { account_name }) {
    state.me.account_name = account_name; localStorage.me = JSON.stringify(state.me)
  },

  SET_UNVERIFIED_PRO: (state, contact) => state.unverifiedPro = contact,
  SET_UNCLAIMED_PRO: (state, pro) => state.unclaimedPro = pro,
  SET_UNCLAIMED_PRO_USER: (state, proUser) => state.unclaimedProUser = proUser,
  SET_REFERRALS: (state, referrals) => state.referrals = referrals,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}